import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { PurchasePlusPageInfoFragmentDoc } from './PageInfo.generated'
import { ReportExecutionsTableViewReportExecutionFragmentDoc } from './ReportExecutionsTableViewReportExecution.generated'
import * as Types from './purchasePlus_graphql'

export const GetReportExecutionsDocument = gql`
  query GetReportExecutions(
    $reportId: Int!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $sorts: [ReportExecutionsQuerySortsInput!]
    $filters: ReportExecutionsQueryFiltersInput
  ) {
    report(id: $reportId) {
      id
      executions(after: $after, before: $before, first: $first, last: $last, sorts: $sorts, filters: $filters) {
        edges {
          node {
            ...ReportExecutionsTableViewReportExecution
          }
        }
        pageInfo {
          ...PurchasePlusPageInfo
        }
      }
    }
  }
  ${ReportExecutionsTableViewReportExecutionFragmentDoc}
  ${PurchasePlusPageInfoFragmentDoc}
` as unknown as DocumentNode<Types.GetReportExecutionsQuery, Types.GetReportExecutionsQueryVariables>
